// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1S9x6","actionsCol":"EnrolledClinics_actionsCol__2EAwH"};